export const formatPreviewTime = (seconds) => {
  const safe = Math.max(0, Number.isFinite(seconds) ? seconds : 0);
  const total = Math.floor(safe);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

export const getPreviewScrollMetrics = (el) => {
  if (!el) {
    return { scrollTop: 0, maxScroll: 0 };
  }
  const maxScroll = Math.max(0, el.scrollHeight - el.clientHeight);
  return { scrollTop: el.scrollTop, maxScroll };
};

export const getScrollRate = (ppf, playbackFps) =>
  Math.max(0.0001, ppf * playbackFps);
